import { db } from "@/firebase"

export default {
  state: {
    user: {
      loggedIn: false,
      data: {}
    }
  },
  getters: {
    user(state) {
      return state.user.data
    }
  },
  mutations: {
    SET_LOGGED_IN(state, value) {
      state.user.loggedIn = value
    },
    SET_USER(state, data) {
      state.user.data = data
    }
  },
  actions: {
    // FETCH USER LIVE
    fetchUser({ commit }, user) {
      commit("SET_LOGGED_IN", user !== null)
      if (user) {
        db.collection("users")
          .doc(user.uid)
          .onSnapshot(function(userDocument) {
            commit("SET_USER", {
              email: user.email,
              name: "NoName",
              type: "Customer",
              uid: user.uid,
              watchHistory: [],
              ...userDocument.data()
            })
          })
      } else {
        commit("SET_USER", null)
      }
    }
  }
}
